import Burger from './Burger';

// Export types
export type { BurgerProps } from './Burger';

// Export components
export { Burger };
export default Burger;
